import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Input } from 'semantic-ui-react';
import { INCLUDE_EXCLUDE_OPTIONS, COMPARISON_OPTIONS } from '../fieldsConfig';

const ConditionBuilder = ({
  conditions,
  ruleId,
  onValueChange,
  disabled,
  allowAddCondition,
  maxConditions = Infinity,
  onAddCondition,
}) => {
  const canAddCondition = allowAddCondition && conditions.length < maxConditions;

  return (
    <div className='condition-builder'>
      {conditions.map((condition, index) => (
        <div
          key={condition.field}
          className='condition-row'
        >
          <Dropdown
            selection
            options={INCLUDE_EXCLUDE_OPTIONS}
            value={condition.includeExclude}
            onChange={(e, data) => onValueChange(ruleId, 'condition', {
              index,
              key: 'includeExclude',
              value: data.value,
            })}
            disabled={disabled}
          />
          <Dropdown
            selection
            options={COMPARISON_OPTIONS}
            value={condition.comparison}
            onChange={(e, data) => onValueChange(ruleId, 'condition', {
              index,
              key: 'comparison',
              value: data.value,
            })}
            disabled={disabled}
          />
          <span className='condition-field'>{condition.field}</span>
          <Input
            type='number'
            value={condition.value}
            onChange={(e, data) => onValueChange(ruleId, 'condition', {
              index,
              key: 'value',
              value: data.value,
            })}
            disabled={disabled}
          />
        </div>
      ))}
      {canAddCondition && (
        <a
          href='#'
          className='add-condition-link'
          onClick={e => {
            e.preventDefault();
            if (onAddCondition) onAddCondition(ruleId);
          }}
          aria-label='Add condition'
          title='Add condition'
        >
          + Add condition
        </a>
      )}
    </div>
  );
};

ConditionBuilder.propTypes = {
  conditions: PropTypes.arrayOf(PropTypes.object).isRequired,
  ruleId: PropTypes.string.isRequired,
  onValueChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  allowAddCondition: PropTypes.bool,
  maxConditions: PropTypes.number,
  onAddCondition: PropTypes.func,
};

export default ConditionBuilder;
